var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"login"},[_c('v-row',{class:[!_vm.$_breakpoints_mobile?
      'login__row' : 'login__row--mobile']},[_c('LoginForm',_vm._b({},'LoginForm',_vm.$props,false)),_c('LoginSlides')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }